const custom = {
    fishImageWidth: function(src) {
        const matches = src.match(/width=([0-9]*)/);

        return matches !== null && matches.length == 2 ? matches[1] : 533;
    },
    calcSizedImageUrl: function(src, size) {
        return `${src}&width=${size}`;
    },
    switchThumbImage: function(src, swatch) {
        const images = swatch.closest('.card').querySelectorAll('.card__media img');
        images.forEach(element => {
            const size = custom.fishImageWidth(element.currentSrc);
            const imageUrl = custom.calcSizedImageUrl(src, size);
            element.srcset = imageUrl;
        });
    },
    switchThumbImageHandler: function(e) {
        if (e.target.tagName !== 'IMG' || e.target.className !== "swatch-image")
            return;

        const swatchEl = e.target.parentElement.parentElement;
        const src = swatchEl.dataset.sibImg;
        custom.switchThumbImage(src, swatchEl);
    },
    restoreOrigThumbImageHandler: function(e) {
        if (e.target.tagName !== 'IMG' || e.target.className !== "swatch-image")
            return;

        const images = e.target.closest('.card').querySelectorAll('.card__media img');
        images.forEach(img => {
            if (img.dataset.srcset) {
                img.srcset = img.dataset.srcset;
            }
        });
    },
    switchBaseImages: function(dataVarToSwitchTo) {
        document.querySelectorAll('img[data-lifestyle-src]').forEach(img => {
            const size = custom.fishImageWidth(img.currentSrc);
            const newSrc = custom.calcSizedImageUrl(img.dataset[dataVarToSwitchTo], size);
            img.srcset = newSrc;
            img.dataset.srcset = newSrc;
        });
    },
    refreshLifestyleState: function() {
        document.querySelectorAll('.lifestyle-toggle [data-lifestyle-toggle].active, .mobile-lifestyle-toggle [data-lifestyle-toggle].active')
            .forEach(el => {
                if (el && el.dataset.lifestyleToggle == 'lifestyleSrc') {
                    custom.switchBaseImages('lifestyleSrc');
                }
            });
    }

};

customMain();
function customMain() {
    document.querySelectorAll('slider-component > ul[id*="featured_collection"], #ProductGridContainer, product-recommendations')
        .forEach( e => {
            // Switch image on product card when user hovers over a swatch
            e.addEventListener('mouseover', custom.switchThumbImageHandler);
            e.addEventListener('mouseout', custom.restoreOrigThumbImageHandler);

            // Check if lifestyle images should be shown by default
            if (e.classList.contains('lifestyle-active')) {
                custom.switchBaseImages('lifestyleSrc');
            }
        });

    // Switch between model and lifestyle product thumbnails
    document.querySelectorAll('.lifestyle-toggle [data-lifestyle-toggle], .mobile-lifestyle-toggle [data-lifestyle-toggle]')
        .forEach( e => {
            e.addEventListener('click', function (e) {
                const el = e.target;
                if (el.classList.contains("active"))
                    return;

                custom.switchBaseImages(el.dataset.lifestyleToggle);
                el.parentElement.querySelector('.active').classList.remove('active');
                el.classList.add('active');
            });
        });
}

const jsMegaMenu = document.querySelectorAll('.js-mega-menu')
// Header Mega Menu
function headerNavigation() {

    if (window.matchMedia("(min-width: 990px)").matches) {
        if(document.getElementById("headerSearchDetails") != undefined) {
            document.getElementById("headerSearchDetails").setAttribute('open', true)
        }
        document.querySelectorAll('.header__inline-menu-item [id^="Details-HeaderMenu-"]').forEach((details) => {
            details.addEventListener('mouseover', (event) => {
                event.currentTarget.open = true;
            });
        
            // details.addEventListener('mouseout', (event) => {
            //     for(var i = 0; i < jsMegaMenu.length; i++) {
            //         jsMegaMenu[i].removeAttribute('open');
            //     }
            // });
        });
        
        window.onmouseover = function(e) {
            if(e.target.classList.contains('modal-overlay')) {
                for(var i = 0; i < jsMegaMenu.length; i++) {
                    jsMegaMenu[i].removeAttribute('open');
                }
            }
        };
    }
}

window.addEventListener('load', function(event) { headerNavigation(); });
window.addEventListener('resize', function(event) {
    headerNavigation();
}, true);

document.querySelectorAll('.menu-drawer__menu-item').forEach((menuItem) => {
    menuItem.addEventListener('click', (event) => {
        document.body.classList.add('submenu-open');
    });
});

document.querySelectorAll('.menu-drawer__close-button').forEach((menuDrawerCloseButton) => {
    menuDrawerCloseButton.addEventListener('click', (event) => {
        const subMenuOpen = Number(document.querySelectorAll('.submenu-open').length);
        if( subMenuOpen > 0 ) {
            document.body.classList.remove('submenu-open');
        }
    });
});
